import * as React from "react";
import type { SVGProps } from "react";
const SvgExclamationInTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 15.96a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1M12 18.96a.84.84 0 0 1-.38-.08 1 1 0 0 1-.33-.21 1.2 1.2 0 0 1-.21-.33 1 1 0 0 1-.08-.38 1 1 0 0 1 0-.19q.015-.1.06-.19a.6.6 0 0 1 .09-.17q.053-.085.12-.16.144-.137.33-.21a1 1 0 0 1 1.09.21q.068.075.12.16.06.078.09.17.045.09.06.19.035.091.04.19a.84.84 0 0 1-.08.38 1.2 1.2 0 0 1-.21.33 1.05 1.05 0 0 1-.71.29"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.505 21.829A1 1 0 0 0 2 21.96h20a1 1 0 0 0 .88-.49 1 1 0 0 0 0-1l-10-18a1 1 0 0 0-1.74 0l-10 18a1 1 0 0 0 0 1 1 1 0 0 0 .365.359M12 5.02l8.3 14.94H3.7z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExclamationInTriangle;
